import { render } from "./phoneNumber.vue?vue&type=template&id=4e87f63e&scoped=true"
import script from "./phoneNumber.vue?vue&type=script&lang=js"
export * from "./phoneNumber.vue?vue&type=script&lang=js"

import "./phoneNumber.vue?vue&type=style&index=0&id=4e87f63e&lang=scss&scoped=true"

import exportComponent from "/usr/src/old_admin_etchite_latest_prod/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e87f63e"]])

export default __exports__